module.exports = __webpack_public_path__ + "img/cloud4.dd884429.png";